
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/delta-3-1000-air-portabe-power-station/specs",
      function () {
        return require("private-next-pages/delta-3-1000-air-portabe-power-station/specs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/delta-3-1000-air-portabe-power-station/specs"])
      });
    }
  